import { render, staticRenderFns } from "./Statcard.vue?vue&type=template&id=6e841fa8&scoped=true&"
import script from "./Statcard.vue?vue&type=script&lang=js&"
export * from "./Statcard.vue?vue&type=script&lang=js&"
import style0 from "./Statcard.vue?vue&type=style&index=0&id=6e841fa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e841fa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VSheet})
